export function normalizeExportPath(path: string): string {
  let p = path.replace(/\\/g, '/').trim();
  p = decodeURIComponent(p);
  while (p.startsWith('./')) {
    p = p.slice(2);
  }
  return p;
}

export function extractNotionIdFromFilename(filename: string): string | null {
  // Database CSVs come in two variants: `Name {hex}.csv` and `Name {hex}_all.csv`.
  const base = filename.replace(/\.(md|csv|html)$/i, '').replace(/_all$/i, '');
  const match = base.match(/([0-9a-f]{32})$/i);
  if (!match) {
    return null;
  }
  const hex = match[1]!.toLowerCase();
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}

export function decodeHtmlEntities(value: string): string {
  return value
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"')
    .replace(/&#0?39;/g, "'")
    .replace(/&apos;/g, "'")
    .replace(/&nbsp;/g, ' ');
}

/** Strip extension, `_all` suffix, `(Inline database)` label and trailing Notion id. */
function cleanExportLabel(value: string): string {
  return decodeHtmlEntities(value)
    .replace(/\.(md|csv|html)$/i, '')
    .replace(/\s*\(inline database\)\s*$/i, '')
    .replace(/_all$/i, '')
    .replace(/\s+[0-9a-f]{32}$/i, '')
    .trim();
}

export function titleFromExportFilename(filename: string): string {
  const cleaned = cleanExportLabel(filename);
  return cleaned || filename;
}

/** Human-readable title for UI (strips Notion id suffixes, `_all`, `(Inline database)`). */
export function displayTitleFromExport(title: string, href: string): string {
  const fromText = cleanExportLabel(title.trim());
  if (fromText) {
    return fromText;
  }
  const fromFile = href ? titleFromExportFilename(href.split('/').pop() ?? href) : '';
  return fromFile || 'Untitled';
}
